module.exports = __webpack_public_path__ + "img/crop.b313cb03.svg";